import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ThemeService } from '../../../common/services/theme.service';

@Component({
    selector: 'not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NotFoundComponent implements OnInit, OnDestroy {
    constructor(private themeService: ThemeService) {}

    ngOnInit(): void {
        this.themeService.forceLightMode();
    }

    ngOnDestroy(): void {
        this.themeService.restoreTheme();
    }
}
